// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Filter */

/* Filter Popover */
.popover-main-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  min-width: 350px;
  padding: 8px;
}

.popover-close-btn-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}

.popover-actions-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.popover-saved-search-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.popover-saved-search-btn {
  height: 2rem;
  border-radius: 6px;
}

.popover-exc-btns-container {
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  padding: 8px 0;
}

.popover-date-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  
}

.toggle-disabled {
  opacity: 20%;
  filter: none;
}

.action-btn-disabled {
  opacity: 20%;
  filter: none;
  cursor: default;
}


.toggle-content {
  display: flex;
  gap: 5px;
  justify-content: space-between;
  width: 100%;
}

.show-more-btn {
  cursor: pointer;
  max-width: 120px;
  border: 0px;
  background-color: transparent;
}


.date-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}

.date-input {
  min-height: 30px;
  min-width: 100px;
  border-radius: 6px;
  padding: 2px 8px;
  border: 0px solid lightgray;
  box-shadow: inset 0 2px 6px 1px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  &:hover {
    filter: brightness(.93);
  };
}

.collapser-container {
  width: 100%;
  margin-bottom: 12px;
  border-radius: 6px;
}

.collapser-container-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 8px;
}`, "",{"version":3,"sources":["webpack://./src/styles/filterStyles.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;;AAE3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,mDAAmD;EACnD,eAAe;EACf;IACE,uBAAuB;EACxB,CAAA;AACH;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* Main Filter */\n\n/* Filter Popover */\n.popover-main-container {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  flex-direction: column;\n  min-width: 350px;\n  padding: 8px;\n}\n\n.popover-close-btn-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  width: 100%;\n}\n\n.popover-actions-container {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.popover-saved-search-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.popover-saved-search-btn {\n  height: 2rem;\n  border-radius: 6px;\n}\n\n.popover-exc-btns-container {\n  display: flex;\n  justify-content: flex-end;\n  gap: 4px;\n  padding: 8px 0;\n}\n\n.popover-date-block {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  \n}\n\n.toggle-disabled {\n  opacity: 20%;\n  filter: none;\n}\n\n.action-btn-disabled {\n  opacity: 20%;\n  filter: none;\n  cursor: default;\n}\n\n\n.toggle-content {\n  display: flex;\n  gap: 5px;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.show-more-btn {\n  cursor: pointer;\n  max-width: 120px;\n  border: 0px;\n  background-color: transparent;\n}\n\n\n.date-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  gap: 10px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.date-input {\n  min-height: 30px;\n  min-width: 100px;\n  border-radius: 6px;\n  padding: 2px 8px;\n  border: 0px solid lightgray;\n  box-shadow: inset 0 2px 6px 1px rgba(0, 0, 0, 0.25);\n  cursor: pointer;\n  &:hover {\n    filter: brightness(.93);\n  };\n}\n\n.collapser-container {\n  width: 100%;\n  margin-bottom: 12px;\n  border-radius: 6px;\n}\n\n.collapser-container-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n  max-height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
